<template>
  <div class="info-list">
    <div class="title">{{name}}</div>
    <div class="link-container" v-if="children.length">
      <router-link class="link" v-for="item in children" :key="item.typeCode" :to="{path: '/newsList', query: {typeCode: item.typeCode, name: item.name}}" :target="isMobile?'_self':'_blank'">{{item.name}}</router-link>
    </div>
    <div class="list-container">
      <div class="list" v-for="item in newsList" :key="item.id">
        <div class="title">
          <router-link :target="isMobile?'_self':'_blank'" class="link" :to="{path:'/newsDetail', query:{id: item.id}}">{{ item.title }}</router-link>
        </div>
        <div class="desc">{{ item.des | wordLimit(130) }}</div>
        <div class="date">{{ item.time | dateFormat('yyyy-MM-dd') }}</div>
        <router-link :target="isMobile?'_self':'_blank'" class="more" :to="{path:'/newsDetail', query:{id: item.id}}">MORE</router-link>
      </div>
    </div>
    <div v-if="newsList.length" class="pagination-container">
      <el-pagination background layout="total, prev, pager, next" :total="total" :page-size="5"  @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <div v-if="!newsList.length" class="no-data">暂无数据</div>
  </div>
</template>

<script>
export default {
  props: ['isMobile'],
  data () {
    return {
      total: 0,
      newsList: [],
      name: '',
      children: [],
      typeObj: {}
    }
  },
  watch: {
    $route: {
      handler (to, from) {
        this.init()
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.typeObj = JSON.parse(window.localStorage.getItem('typeObj'))
      const query = this.$route.query
      this.typeCode = []
      this.children = []
      this.title = ''
      if (this.typeObj && query.type) {
        this.typeObj[query.type].forEach(v => {
          this.typeCode.push(v.dictCode)
          this.children.push({ name: v.dictLabel, typeCode: v.dictCode })
        })
      }
      if (query.typeCode) {
        this.typeCode = [].concat(query.typeCode.split(','))
      }
      if (query.searchStr) {
        this.title = query.searchStr
        this.$emit('getStr', this.title)
      }
      if (query.name) {
        this.name = query.name
      }
      this.getInfo({})
    },

    getInfo (param) {
      const target = Object.assign({}, { pageNum: 1, pageSize: 5, typeCode: this.typeCode, title: this.title }, param)
      this.$axios.post(process.env.VUE_APP_jiaxingUrl + '/system/open/getTextListByPage', target).then(res => {
        const data = res.data
        this.newsList = data.rows
        this.total = data.total
      })
    },
    handleCurrentChange (pageNum) {
      this.getInfo({ pageNum })
    },
    changeKeyword (title) {
      this.getInfo({ title })
    }
  }
}
</script>

<style lang="scss" scoped>
.info-list {
  min-height: calc(100vh - 625px);
  width: 1200px;
  margin: 0 auto;
  .title {
    position: relative;
    height: 120px;
    line-height: 40px;
    font-size: 32px;
    font-weight: 600;
    color: #4370ca;
    font-family: MicrosoftYaHei-Bold;
    text-align: center;
    &::after {
      content: "";
      position: absolute;
      left: 50%;
      top: 50px;
      width: 80px;
      height: 4px;
      background-color: #4370ca;
      transform: translateX(-50%);
    }
  }
  .link-container {
    display: flex;
    justify-content: center;
    margin-bottom: 40px;
    margin-top: -30px;
    position: relative;
    z-index: 100;
    .link {
      width: 120px;
      height: 36px;
      line-height: 36px;
      text-decoration: none;
      color: #4370ca;
      border: 1px solid #4370ca;
      text-align: center;
      font-size: 18px;
      border-radius: 4px;
      font-weight: 600;
      & + .link {
        margin-left: 60px;
      }
    }
  }
  .list-container {
    .list {
      position: relative;
      width: 1200px;
      height: 240px;
      padding: 20px 40px;
      border-radius: 20px;
      box-shadow: 0px 7px 29px 0px rgba(3, 6, 5, 0.08);
      & + .list {
        margin-top: 30px;
      }
      &:hover {
        background-color: #457ae3;
        .title {
          .link {
            color: #fff;
          }
        }
        .desc {
          color: #fff;
        }
        .date {
          color: #fff;
        }
        .more {
          color: #fff;
          border-color: #fff;
          &::after {
            border-right-color: #fff;
            border-top-color: #fff;
          }
        }
      }
      .title {
        height: 44px;
        line-height: 44px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 20px;
        color: #333;
        font-weight: 600;
        .link {
          color: #333;
          text-decoration: none;
        }
      }
      .desc {
        margin-top: 16px;
        line-height: 24px;
        font-size: 16px;
        color: #888;
      }
      .date {
        margin-top: 64px;
        color: #888;
      }
      .more {
        position: absolute;
        right: 40px;
        bottom: 20px;
        color: #888;
        text-decoration: none;
        width: 102px;
        height: 38px;
        line-height: 38px;
        border: 1px solid #888;
        border-radius: 10px;
        text-indent: 21px;
        font-size: 14px;
        cursor: pointer;
        &::after {
          position: absolute;
          content: "";
          top: 14px;
          right: 20px;
          width: 5px;
          height: 5px;
          border: 1px solid #888;
          border-bottom-color: transparent;
          border-left-color: transparent;
          transform: rotate(45deg);
        }
      }
    }
  }
  .pagination-container {
    margin: 70px 0;
  }
  .no-data {
    line-height: 60px;
    text-align: center;
    font-size: 20px;
  }
}
</style>
